import numeral from 'numeral';
import React from 'react';
import { FormattedNumber } from 'react-intl';

import { getConversionFromUSD } from 'utils/currency';

const Currency = ({
  amount,
  currency = 'USD',
  decimal_places = 2,
  exchange_rate = 1,
}: {
  amount?: number | string;
  currency?: string;
  decimal_places?: number;
  exchange_rate?: number;
}) => (
  <FormattedNumber
    currency={currency}
    minimumFractionDigits={decimal_places}
    maximumFractionDigits={decimal_places}
    value={getConversionFromUSD({
      exchange_rate,
      value: numeral(amount).value(),
    })}
    {...{ style: 'currency' }}
  />
);

export default Currency;
